import React from 'react';

/**
 * AdUnit — banner Adsterra via iframe aislado.
 * Los scripts corren dentro del iframe, sin interferencia de React.
 */
function AdUnit({ adKey = 'd7852f1531c18bd0df63dfdde10d80c4', width = 300, height = 250, style = {} }) {
  const srcDoc = `<!DOCTYPE html>
<html>
<head>
  <style>
    * { margin: 0; padding: 0; }
    body { background: transparent; overflow: hidden; }
  </style>
</head>
<body>
  <script>
    atOptions = {
      'key'    : '${adKey}',
      'format' : 'iframe',
      'height' : ${height},
      'width'  : ${width},
      'params' : {}
    };
  <\/script>
  <script src="https://www.highperformanceformat.com/${adKey}/invoke.js"><\/script>
</body>
</html>`;

  return (
    <iframe
      srcDoc={srcDoc}
      width={width}
      height={height}
      frameBorder="0"
      scrolling="no"
      title="ad"
      sandbox="allow-scripts allow-same-origin allow-popups allow-top-navigation"
      style={{
        display:      'block',
        margin:       '0 auto',
        border:       'none',
        borderRadius: '8px',
        ...style,
      }}
    />
  );
}

export default AdUnit;
